import { Table, Box } from '@flos/react-ui';
import TableRow from '../../../../shared_components/TableRow/TableRow';
import type { ConditionExclusionManualTextDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/common';
import ConditionsAndExclusionsModal from '../../../../shared_components/ConditionsAndExclusionsModal/ConditionsAndExclusionsModal';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';
import { useRecoilValue } from 'recoil';
import { businessFlowSelector } from '../../../../recoil/selectors/getBusinessFlowSelector';

const ShoppingBasketSpecialConditions = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const conditionsAndExclusionsDTO = coverable.conditionExclusionManualTexts ?? [];
    const businessFlow = useRecoilValue(businessFlowSelector);
    if (conditionsAndExclusionsDTO.length === 0 || businessFlow === 'OPC') {
        return <></>;
    }

    return (
        <Box className="u-border-none u-shadow-none">
            <div className="u-flex-box u-flex-box--space-between">
                <h4>Særlige vilkår for din forsikring</h4>
            </div>
            <Table mobileDirection="vertical">
                <Table.Body>
                    {conditionsAndExclusionsDTO.map(
                        (condition: ConditionExclusionManualTextDTO) => {
                            return (
                                <TableRow
                                    rowInfo={{
                                        name: condition.name ?? '',
                                        labelType: 'modalLink',
                                        modalInformation: {
                                            modalType: ConditionsAndExclusionsModal,
                                            modalProps: {
                                                title: condition.name ?? '',
                                                description: condition.text ?? ''
                                            }
                                        }
                                    }}
                                    hideFieldValue={true}
                                    key={condition.publicID}
                                />
                            );
                        }
                    )}
                </Table.Body>
            </Table>
        </Box>
    );
};

export default ShoppingBasketSpecialConditions;
